<div class="dash-container">
  <div class="cards-grid">
    <app-agency-dash-card
      *ngFor="let item of menu"
      [desc]="item.desc"
      [path]="item.path"
      [btnText]="item.btnText"
      [icon]="'assets/icons/' + item.icon + '-grey.svg'"
    ></app-agency-dash-card>
  </div>
</div>


